module.exports = __webpack_public_path__ + "static/media/05_leitstand.f0aebbc0.png";


//////////////////
// WEBPACK FOOTER
// ../assets/icons/05_leitstand.png
// module id = 846
// module chunks = 0